module.exports = __webpack_public_path__ + "media/images/admin/icons/book-open-67a128a70b4eaa20f68b805e7ef71e42.svg";